import _ from 'lodash';
import isReactProp from 'is-react-prop';

//Cleans known react-redux-form extra props to remove warning
export function cleanProps(props) {
  const validProps = {};
  _.forOwn(props, function (value, key) {
    if (isReactProp(key)) {
      validProps[key] = value;
    }
  });
  return validProps;
}
